import { Button, Stack } from '@mui/material';
import { RestartAlt, Save } from '@mui/icons-material';
import React, { useCallback, useMemo, useState } from 'react';
import { CenteredColumn } from 'src/Common/Components/Stacks';
import { StyledTextField } from 'src/Common/Components/Forms/StyledTextField';
import useEkko from 'src/Common/Providers/EkkoProvider';
import useRequest from 'src/Common/Hooks/useRequest';
import { LoadingMask } from 'src/Common/Components/LoadingMask';

export const ChangePasswordForm = (): React.JSX.Element => {
  const { api } = useEkko();

  const [password, setPassword] = useState<string>('');
  const [passwordConfirm, setPasswordConfirm] = useState<string>('');

  const [isLoading, startLoading] = useRequest();

  const isSavable = useMemo(() => password !== '' && passwordConfirm === password, [password, passwordConfirm]);
  const helperText = useMemo(() => (!isSavable ? 'Does not match' : ''), [isSavable]);

  const reset = useCallback(() => {
    setPassword('');
    setPasswordConfirm('');
  }, []);

  const save = useCallback(() => {
    if (!isSavable) {
      return;
    }
    startLoading(
      () => api.updateCurrentUsersPassword(password),
      () => reset(),
    );
  }, [api, password]);

  if (isLoading) {
    return <LoadingMask />;
  }

  return (
    <CenteredColumn>
      <StyledTextField
        type={'password'}
        label={'New Password'}
        value={password}
        onChange={(e) => setPassword(String(e.target.value))}
      />
      <StyledTextField
        type={'password'}
        label={'Confirm Password'}
        value={passwordConfirm}
        onChange={(e) => setPasswordConfirm(String(e.target.value))}
        helperText={helperText}
      />
      <Stack direction={'row'} spacing={2} justifyContent={'center'}>
        <Button variant={'outlined'} color={'primary'} onClick={reset} startIcon={<RestartAlt />}>
          Reset
        </Button>
        <Button variant={'contained'} color={'primary'} disabled={!isSavable} onClick={save} endIcon={<Save />}>
          Save
        </Button>
      </Stack>
    </CenteredColumn>
  );
};
